import { useNavigate } from 'react-router-dom'
import './About.scss'
import { useEffect, useState } from 'react'
import Skills from './Skills'

export default function About({ music, isMobile }) {
  const navigate = useNavigate()

  const [isSmallerDesktopScreen, setIsSmallerDesktopScreen] = useState(false)

  useEffect(() => {
    // Delay the rendering of buttons for 5 seconds
    const timer = setTimeout(() => {
      // Add the CSS class to make the buttons visible
      const elements = document.querySelectorAll('.hide-elements')
      elements.forEach((element) => {
        element.classList.remove('hide-elements')
        element.classList.add('show-elements')
      })
    }, 800)

    // Clear the timer if the component unmounts
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsSmallerDesktopScreen(window.innerWidth <= 1318)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className='about-me'>
      <div className='about-card'>
        <button className='hide-elements go-back' onClick={() => navigate('/')}>
          <div className='nav-icon'>
            <div className='arrows'></div>
          </div>
        </button>
        <h1 className='hide-elements header-text'>Meet my amazing Hero</h1>
        <div className='hide-elements flex row w-100'>
          <div
            className={`column ${
              isSmallerDesktopScreen ? 'w-100' : 'w-46 pr-2'
            } `}
          >
            <h2 className='category-title'>ATTRIBUTES</h2>
            <div className='row w-100 pb-3 pt-1'>
              <div className='field w-38 pr-1'>
                <label className='glow text'>Name</label>
                <input
                  readOnly
                  disabled
                  type='text'
                  value='Najlae'
                  pattern='\w+'
                />
              </div>
              <div className='field w-61'>
                <label className='glow text'>Title</label>
                <select>
                  <option value='software-engineer'>Software Engineer</option>
                  <option value='web-developer'>Web Developer</option>
                  <option value='game-programmer'>Game Programmer</option>
                  <option value='creative-developer'>Creative Developer</option>
                </select>
              </div>
            </div>
            <div className='row w-100'>
              <div className='field w-33 pr-1'>
                <label className='glow text'>Sex</label>
                <input readOnly disabled value='Female' />
              </div>
              <div className='field w-33 pr-1'>
                <label className='glow text'>Origin</label>
                <input readOnly disabled value='Morocco' />
              </div>
              <div className='field w-33' data-unit='Yrs'>
                <label className='glow text'>Age</label>
                <input readOnly disabled value='23' type='number' />
              </div>
            </div>
          </div>
          {!isSmallerDesktopScreen && (
            <div className='column w-49'>
              <h2 className='category-title'>BIOGRAPHY</h2>
              <div className='flex column w-100'>
                <label className='glow text'>Master's Journey</label>
                <textarea
                  defaultValue='Najlae discovered programming at 17, quickly progressing to become a software engineer and creative developer. After mastering 3D and Three.js, she expanded her skills into game programming with Unreal Engine during her college graduation project. Now, Najlae is eager to apply her creativity and technical expertise in web development, seeking a role that offers both challenges and growth opportunities.'
                  disabled
                  readOnly
                  name='story'
                  rows='6'
                  cols='55'
                ></textarea>
              </div>
            </div>
          )}
        </div>
        {isSmallerDesktopScreen && (
          <div className='flex row w-100'>
            <div className='column w-100'>
              <h2 className='category-title mt-2'>BIOGRAPHY</h2>
              <div className='flex column w-100'>
                <label className='glow text'>Master's Journey</label>
                <textarea
                  defaultValue='Najlae discovered programming at 17, quickly progressing to become a software engineer and creative developer. After mastering 3D and Three.js, she expanded her skills into game programming with Unreal Engine during her college graduation project. Now, Najlae is eager to apply her creativity and technical expertise in web development, seeking a role that offers both challenges and growth opportunities.'
                  disabled
                  readOnly
                  name='story'
                  rows={isMobile ? 12 : 9}
                ></textarea>
              </div>
            </div>
          </div>
        )}
        <Skills />
      </div>
    </div>
  )
}
